export interface PortalTableClipboardGrid {
  headers: string[]
  rows: string[][]
}

export function parsePortalTableClipboard(value: string): PortalTableClipboardGrid {
  const records = parseTabSeparatedRecords(value)
  if (records.length === 0) return { headers: [], rows: [] }

  const width = Math.max(...records.map((record) => record.length))
  const normalized = records.map((record) => [
    ...record,
    ...Array.from({ length: width - record.length }, () => ''),
  ])

  return {
    headers: normalized[0],
    rows: normalized.slice(1),
  }
}

function parseTabSeparatedRecords(value: string) {
  const records: string[][] = []
  let record: string[] = []
  let cell = ''
  let quoted = false

  for (let index = 0; index < value.length; index += 1) {
    const character = value[index]
    const next = value[index + 1]

    if (character === '"') {
      if (quoted && next === '"') {
        cell += '"'
        index += 1
      } else if (quoted || cell.length === 0) {
        quoted = !quoted
      } else {
        cell += character
      }
      continue
    }

    if (!quoted && character === '\t') {
      record.push(cell)
      cell = ''
      continue
    }

    if (!quoted && (character === '\n' || character === '\r')) {
      if (character === '\r' && next === '\n') index += 1
      record.push(cell)
      records.push(record)
      record = []
      cell = ''
      continue
    }

    cell += character
  }

  record.push(cell)
  records.push(record)
  if (records.length > 1 && records[records.length - 1].every((entry) => entry === '')) {
    records.pop()
  }
  return records
}
